import ClazzCourseApi from '../../../api/src/clazz_course/api/ClazzCourseApi'
import {message} from "ant-design-vue";

const clazzCourseApi = new ClazzCourseApi();

const state = {

}

const mutations = {

}

const actions = {
    // 班课分页列表
    findClazzCourse: ({commit}, query) => {
        return new Promise((resolve, reject) => {
            clazzCourseApi.findPagingClazzCourse(query.pageNum, query.companyId, query.body).then(res => {
                resolve(res)
            }).catch(err => {
                message.error(err.message)
                reject(err)
            })
        })
    },
    // 班课分页列表
    addClazzCourse: ({commit}, query) => {
        return new Promise((resolve, reject) => {
            clazzCourseApi.findPagingClazzCourse(query.pageNum, query.companyId, query.body).then(res => {
                resolve(res)
            }).catch(err => {
                message.error(err.message)
                reject(err)
            })
        })
    },

}

export default {
    // namespaced: true,
    state,
    actions,
    mutations
}
